export const GenerateImagePromptsExamples = [
  {
    prompt:
      "In the next scene, a 2D fancy stack of golden-brown pancakes appears on the screen, glistening with syrup and topped with fresh strawberries and a dollop of whipped cream. The background is a softly blurred, luxurious kitchen with high-quality lighting, emphasizing the food.",
    image: "/images/Suites/imgEx1.png",
  },
  {
    prompt:
      "Create a cinematic and colorful scene featuring a cute white and brown rabbit peacefully sleeping. Next to the rabbit, place two fresh, vibrant carrots and a cup of milk. The atmosphere should be cozy and serene, with soft lighting and a gentle, dreamy background. The setting should have soft, natural elements—like grass, flowers, or a warm, sunlit nook. The colors should be rich and inviting, creating a tranquil, heartwarming feel.",
    image: "/images/imgEx2.png",
  },
  {
    prompt:
      "A cute and kind grandma with a warm smile, giving freshly baked bread in a cozy room during the daytime. Sunlight streams through a large window, illuminating the wooden table with a basket of bread and a steaming cup of tea. The grandma has soft wrinkles, wears a traditional apron, and has gentle, expressive eyes. The room has a homely feel with warm colors, a rustic bookshelf, and potted plants near the window. The scene is heartwarming and inviting, drawn in a colorful 2D anime style with soft shading and vibrant details.",
    image: "/images/imgEx3.png",
  },
];

export const GenerateLogosPromptsExamples = [
  {
    prompt:
      "A minimalist coffee shop logo, with a single-line drawing of a steaming cup and soft, earthy tones.",
    image: "/images/Suites/logoEx1.png",
  },
  {
    prompt:
      "A clean and professional law firm logo, with bold serif typography and a small, abstract pillar icon.",
    image: "/images/Suites/logoEx2.png",
  },
  {
    prompt:
      " A simple yet stylish pet shop logo, featuring a minimalist cat silhouette inside a soft, rounded paw print.",
    image: "/images/Suites/logoEx3.png",
  },
];

export const GenerateIconsPromptsExamples = [
  {
    prompt:
      " Create a modern, minimalist music app icon in a flat design style. The icon should be square with rounded corners, featuring a sleek musical note in white on a vibrant gradient background (blue to purple). The edges should be smooth, with a subtle shadow for depth.",
    image: "/images/Suites/icnEx1.png",
  },
  {
    prompt:
      "Design a high-quality fantasy-themed dragon head icon in a semi-realistic style. The icon should be circular, with a fierce-looking dragon breathing fire. The colors should be deep reds and golds, with glowing eyes and sharp details. A dark gradient background enhances the contrast.",
    image: "/images/Suites/icnEx2.png",
  },
  {
    prompt:
      " Generate a clean, professional settings gear icon in a flat vector style. The icon should be monochrome (dark gray) with sharp, well-defined edges. It should have a subtle drop shadow for visibility and a transparent background.",
    image: "/images/Suites/icnEx3.png",
  },
];

export const GenerateIllustrationsPromptsExamples = [
  {
    prompt:
      "A young girl reading a book under a large oak tree, her face illuminated by the golden light of sunset. Leaves fall gently around her, and a cat curls up beside her on the grass.A young girl reading a book under a large oak tree, her face illuminated by the golden light of sunset. Leaves fall gently around her, and a cat curls up beside her on the grass.",
    image: "/images/Suites/illsEx1.png",
  },
  {
    prompt:
      "A father teaching his child to ride a bicycle, in a peaceful suburban neighborhood during the golden hour. The child’s face is filled with determination, and the father smiles encouragingly.",
    image: "/images/Suites/illsEx2.png",
  },
  {
    prompt:
      "A massive alien planet with two suns, its landscape covered in bioluminescent forests and floating rock formations. Strange creatures roam in the distance.",
    image: "/images/Suites/illsEx3.png",
  },
];

export const zoomOptions = [100, 110, 120, 130, 140, 150, 175, 200, 250, 300];